import API from "./api"

export default function useAddDealComparables({ deal, topic }) {
  const path =
    topic === undefined
      ? `deals/${deal.id}/comparables/deals`
      : `deals/${deal.id}/comparables/topics/${topic.id}/records`

  return async (comparables) => {
    await API.post(path, {
      comparable_id: comparables.map((comparable) => comparable.id),
    })
  }
}
